import { useState, useEffect, useCallback } from 'react';
import { createAPIClient } from 'api/client';

export const useAnnouncementsState = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [apiClient, setApiClient] = useState(null);
  const [updateCounter, setUpdateCounter] = useState(0);

  useEffect(() => {
    const initAPI = async () => {
      try {
        const client = await createAPIClient();
        setApiClient(client);
      } catch (error) {
        console.error('Failed to initialize API client:', error);
      }
    };
    initAPI();
  }, []);

  const fetchAnnouncements = useCallback(async () => {
    if (!apiClient) return;
    
    try {
      const data = await apiClient.announcements.list();
      setAnnouncements(data || []);
    } catch (error) {
      console.error('Error fetching announcements:', error);
    }
  }, [apiClient]);

  // Fetch announcements when apiClient is ready or when updateCounter changes
  useEffect(() => {
    if (apiClient) {
      fetchAnnouncements();
    }
  }, [apiClient, updateCounter, fetchAnnouncements]);

  const updateAnnouncement = async (announcementData) => {
    if (!apiClient) {
      throw new Error('API client not initialized');
    }

    try {
      let data;
      if (announcementData._delete) {
        data = await apiClient.announcements.delete(
          announcementData.id,
          announcementData.organization_id
        );
      } else {
        data = await apiClient.announcements.update(announcementData);
      }
      
      console.log('Server response data:', data);
      
      if (!data) {
        console.error('Invalid server response - no data returned');
        throw new Error('Invalid server response - no data returned');
      }

      // Trigger a re-fetch instead of updating state directly
      setUpdateCounter(c => c + 1);

      return { data, error: null };
    } catch (error) {
      console.error('Error updating announcement:', error);
      return { data: null, error };
    }
  };

  return {
    announcements,
    setAnnouncements,
    updateAnnouncement,
  };
}; 